import { Link } from 'react-router-dom'
import '../css/Report.css'
import PageHeader from './utils/PageHeader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAddressCard,
  faShoppingCart,
  faFileInvoiceDollar,
  faReceipt,
  faArrowRotateLeft
} from '@fortawesome/free-solid-svg-icons'
import { Col, Row } from 'reactstrap'

const Reports = () => {
  return (
    <>
      <PageHeader
        pageName='REPORTS'
        breadcrump1='Home'
        breadcrump2='Reports'
        link='/reports'
      />

      <div className='page-container'>
        <div className='report-card-container'>
          {/* Card 1 */}
          <Row>
            <Col md={6}>
              <Link to='/lead-report' className='report-card-link'>
                <div className='report-card split-card border1'>
                  <div className='icon-section1'>
                    <FontAwesomeIcon icon={faAddressCard} className='report-icon' />
                  </div>
                  <div className='text-section'>
                    <h5 className='report-card-title'>Lead Details</h5>
                    <p className='report-card-subtitle'>
                      View detailed information of all captured leads.
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col md={6}>
              <Link to='/order-booking' className='report-card-link'>
                <div className='report-card split-card border2'>
                  <div className='icon-section2'>
                    <FontAwesomeIcon
                      icon={faShoppingCart}
                      className='report-icon'
                    />
                  </div>
                  <div className='text-section'>
                    <h5 className='report-card-title'>Order Booking Report</h5>
                    <p className='report-card-subtitle'>
                      View detailed information of all sales orders.
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col md={6} className='mt-4'>
              <Link to='/invoice-report' className='report-card-link'>
                <div className='report-card split-card border3'>
                  <div className='icon-section3'>
                    <FontAwesomeIcon
                      icon={faFileInvoiceDollar}
                      className='report-icon'
                    />
                  </div>
                  <div className='text-section'>
                    <h5 className='report-card-title'>Invoicing Report</h5>
                    <p className='report-card-subtitle'>
                      View detailed information of all generated invoices.
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col md={6} className='mt-4'>
              <Link to='/invoice-wise-report' className='report-card-link'>
                <div className='report-card split-card border1'>
                  <div className='icon-section1'>
                    <FontAwesomeIcon
                      icon={faReceipt}
                      className='report-icon'
                    />
                  </div>
                  <div className='text-section'>
                    <h5 className='report-card-title'>Invoice Wise Report</h5>
                    <p className='report-card-subtitle'>
                      View invoice-level totals — one row per invoice.
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col md={6} className='mt-4'>
              <Link to='/credit-note-wise-report' className='report-card-link'>
                <div className='report-card split-card border2'>
                  <div className='icon-section2'>
                    <FontAwesomeIcon
                      icon={faArrowRotateLeft}
                      className='report-icon'
                    />
                  </div>
                  <div className='text-section'>
                    <h5 className='report-card-title'>Credit Note Wise Report</h5>
                    <p className='report-card-subtitle'>
                      View credit note-level totals — one row per credit note.
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
          </Row>

        </div>
      </div>
    </>
  )
}

export default Reports
